import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { queryKeys } from "../../query";
import { TallyFormsResponseData } from "../../types/tally";

const fetchTallyForms = async (): Promise<TallyFormsResponseData> => {
  const { data } =
    await createApiWithPath("tally").get<TallyFormsResponseData>("/forms");

  return data;
};

export const useTallyForms = () => {
  return useQuery(queryKeys.tallyForms(), fetchTallyForms, {
    refetchOnMount: true,
  });
};
